<div class="tw-overflow-auto tw-h-screen tw-rounded md:tw-h-full">
  <section class="modal-header">
    <h1 class="modal-title text-center tw-text-[1rem] md:tw-text-[2rem]" id="confirmation-modal-title">{{title}}</h1>
    <sam4-close-button (click)="close()"></sam4-close-button>
  </section>
  <main
    id="confirmation-modal-body"
    class="confirm modal-body tw-text-xs tw-overflow-y-auto tw-overflow-x-auto tw-max-h-screen tw-text-[0.6rem] md:tw-text-[1.25rem] md:tw-text-md lg:tw-overflow-hidden lg:tw-min-h-fit"
    >
    <div [innerHTML]="message" class="text-center"></div>
  </main>
  @if (showActionButtons) {
    <section
      class="modal-footer !tw-flex !tw-justify-around !tw-flex-nowrap tw-flex-row-reverse"
      style="margin-top:24px;">
      <button (click)="cancel()" [attr.aria-label]="cancelBtn" class="btn btn-outline-primary"
      data-dismiss="modal" type="button">{{cancelBtn}}</button>
      <button #element (click)="confirm()" [class.btn-warning]="warning"
      [attr.aria-label]="confirmBtn" class="btn btn-primary" type="submit">{{confirmBtn}}</button>
    </section>
  }
  @if (!showActionButtons) {
    <section
      class="modal-footer !tw-flex !tw-justify-around !tw-flex-nowrap tw-flex-row-reverse"
      style="margin-top:24px;">
      <button #element (click)="close()"
      [attr.aria-label]="confirmBtn" class="btn btn-primary" type="submit">Ok</button>
    </section>
  }
</div>

